import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Polygon } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function Arrow(props) {
  const { width, height, color, thickness, direction } = props;

  let coordinates;
  switch (direction) {
    case 'up':
      coordinates = getUpArrowPoints(width, height, thickness);
      break;
    case 'down':
      coordinates = getDownArrowPoints(width, height, thickness);
      break;
    case 'left':
      coordinates = getLeftArrowPoints(width, height, thickness);
      break;
    default:
      coordinates = getRightArrowPoints(width, height, thickness);
  }

  const points = coordinates
    .map((coordinate) => `${coordinate.x},${coordinate.y}`)
    .join(' ');

  return (
    <Svg width={width} height={height}>
      <Polygon fill={color} points={points} />
    </Svg>
  );

  function getRightArrowPoints(arrowWidth, arrowHeight, arrowThickness) {
    return [
      { x: 0, y: 0 },
      { x: arrowThickness, y: 0 },
      { x: arrowWidth, y: arrowHeight / 2 },
      { x: arrowThickness, y: arrowHeight },
      { x: 0, y: arrowHeight },
      { x: arrowWidth - arrowThickness, y: arrowHeight / 2 },
    ];
  }

  function getLeftArrowPoints(arrowWidth, arrowHeight, arrowThickness) {
    return [
      { x: arrowWidth - arrowThickness, y: 0 },
      { x: arrowWidth, y: 0 },
      { x: arrowThickness, y: arrowHeight / 2 },
      { x: arrowWidth, y: arrowHeight },
      { x: arrowWidth - arrowThickness, y: arrowHeight },
      { x: 0, y: arrowHeight / 2 },
    ];
  }

  function getDownArrowPoints(arrowWidth, arrowHeight, arrowThickness) {
    return [
      { x: 0, y: 0 },
      { x: arrowWidth / 2, y: arrowHeight - arrowThickness },
      { x: arrowWidth, y: 0 },
      { x: arrowWidth, y: arrowThickness },
      { x: arrowWidth / 2, y: arrowHeight },
      { x: 0, y: arrowThickness },
    ];
  }

  function getUpArrowPoints(arrowWidth, arrowHeight, arrowThickness) {
    return [
      { x: 0, y: arrowHeight },
      { x: arrowWidth /2 , y: arrowThickness },
      { x: arrowWidth, y: arrowHeight },
      { x: arrowWidth, y: arrowHeight - arrowThickness },
      { x: arrowWidth / 2, y: 0 },
      { x: 0, y: arrowHeight - arrowThickness },
    ];
  }
}

Arrow.defaultProps = {
  direction: 'right',
};

Arrow.propTypes = {
  direction: PropTypes.oneOf(['right', 'down', 'left', 'up']),
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  thickness: PropTypes.number.isRequired,
};

export default pure(Arrow);
